import * as React from 'react';

function HappyStudentsIcon(props) {
	return (
		<svg width={20} height={24} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.78 8.282h6.348a3.4 3.4 0 1 1-6.577 1.216c.002-.416.08-.83.23-1.216ZM9.953 0 2.085 2.713v1.52L1.229 9.07c.385.236.806.35 1.127.35.319 0 .74-.114 1.125-.35l-.824-4.659 3.17.991-.84 3.078A5.069 5.069 0 1 0 15.02 9.498a5.002 5.002 0 0 0-.102-1.018l-.84-3.07 3.741-1.178v-1.52L9.952 0Z'
				fill='#153c4f'
			/>
			<path
				d='M14.13 15.145 10.245 18.4a.463.463 0 0 1-.591 0l-3.881-3.254-3.478 1.884c-.75.407-1.032.76-1.304 1.401L.05 20.64c-.197.843.217 1.162.596 1.277 1.61.362 6.179 1.085 9.305 1.085 3.127 0 7.695-.723 9.307-1.084.378-.116.792-.435.597-1.278l-.942-2.209c-.273-.64-.552-.994-1.303-1.401l-3.48-1.886Z'
				fill='#153c4f'
			/>
		</svg>
	);
}

export default HappyStudentsIcon;
